import type { InjectionKey, Ref } from 'vue';

export interface SidebarControls {
  sidebarHidden: Ref<boolean>;
  sidebarOpen: Ref<boolean>;
  toggleHidden: () => void;
  toggleOpen: () => void;
}

export const sidebarControlsKey: InjectionKey<SidebarControls> = Symbol('sidebarControls');
